<script>
  export function error(err) {
  var errorEl = document.createElement('div');
  errorEl.textContent = 'Error! ' + err.message;
  document.body.insertBefore(
  errorEl,
  document.body.firstChild
  );
}
</script>


<div class="grid-container">
  <div class="grid-row padding-y-2 clearfix" style="align-content: end !important;">
    <button class="usa-button float-right" (click)="initiateSSO()">GSA Employee Login</button>
  </div>
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <app-announcements [broadcastMessages]="broadCastMessages"></app-announcements>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
      @if (!isUserAgentChrome) {
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">This website is best viewed in Chrome Browser</p>
          </div>
        </div>
      }

      @if (errorMessage) {
        <div class="usa-alert usa-alert--error usa-alert--slim margin-right-1 margin-left-1" role="alert">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{errorMessage}}
            </p>
          </div>
        </div>
      }
      <div class="m-2">
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              <b>Important: SMS (text message) and voice (phone call) multi-factor authentication (MFA) are no longer supported as of February 1, 2026.</b>
              If you were using one of these methods, you will be prompted to set up a new authentication factor when you log in on or after February 2, 2026.
              Follow the on-screen instructions to complete the setup. You will not be locked out of your account. For more information and instructions
              on updating your MFA methods, please see our<a class="usa-link" target="" href="javascript:void(0)" (click)="downloadFaq()">
            FAQs</a>.
          </p>
        </div>
      </div>
    </div>
    <div class="usa-card padding-top-2">
      <div class="usa-card__container">
        <header class="usa-card__header">
          <h2 class="usa-card__heading">GSA Multi-Factor Authentication (MFA) - Sign In</h2>
        </header>
        <div class="usa-card__body">
          <div id="okta-sign-in" class="w-100 bg-white border-0 m-0"></div>
        </div>
        <div class="usa-card__footer">
          For technical assistance with TMSS 2.0 or to change the way you currently receive the required "Code" (OKTA Verify,
          Email, Authenticator App etc.),
          please email: <a
        href="mailto:gsatmsshelp@gsa.gov" style="font-weight:bold">gsatmsshelp&#64;gsa.gov</a> for assistance
      </div>
    </div>
  </div>
</div>
<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
</div>
</div>
</div>
